import { useEffect } from "react"
import withStyles from "react-jss"
import colors from "../../data/colors"
import { SECTION_MAX_WIDTH, MAX_WIDTH } from "../../data/globalStyles"
import { IntroTextSection } from ".."

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    position: "relative",
    boxSizing: "border-box",
    width: "100%",
    maxWidth: SECTION_MAX_WIDTH,
    margin: "0 auto",
    marginTop: ({ intro }) => (intro ? "50vh" : 0),
  },
  textContainer: {
    boxSizing: "border-box",
    width: "100%",
    zIndex: 2,
  },
  sticky: {
    boxSizing: "border-box",
    position: "sticky",
    bottom: 0,
    width: "100%",
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    // marginBottom: "-60vh",
    [`@media only screen and (max-width: ${MAX_WIDTH})`]: {
      //marginBottom: "-32vh",
    },
  },
  title: {
    color: colors.white,
    fontSize: "48px",
    fontFamily: "WiredMono",
    textTransform: "uppercase",
    textAlign: "center",
    padding: "0 16px",
    lineHeight: "58px",
    maxWidth: MAX_WIDTH,
    // margin: "64px 0",
    background: "black",
    transition: `opacity 1s ease-in`,
  },
  invisibleTrigger: {
    width: "100%",
    height: "40px",
    background: "transparent",
    pointerEvents: "none",
    margin: "100vh 0 -100vh 0",
  },
  invisibleTickerTrigger: {
    width: "100%",
    height: "40px",
    background: "transparent",
    pointerEvents: "none",
    margin: "100vh 0 -100vh 0",
    color: "#ffffff",
  },
}

const IntroStickySectionDivider = ({ classes, title, setHideTicker }) => {
  useEffect(() => {
    const items = [
      {
        root: document.querySelector("#stickySectionDivider-trigger"),
        threshold: 0.5,
      },
    ]
    const detectIntersection = (entries) => {
      for (let e of entries) {
        // let j = items.indexOf(e.target)
        if (e.isIntersecting) {
          setHideTicker(true)
        } else {
          setHideTicker(false)
        }
      }
    }
    const observer = new IntersectionObserver(detectIntersection, items)
    items.forEach((i) => observer.observe(i.root))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      <section className={classes.container}>
        <div className={classes.textContainer}>
          <div
            id="stickyTicker-trigger"
            className={classes.invisibleTickerTrigger}
            aria-hidden="true"
          />
          <IntroTextSection />
          <div
            id="stickySectionDivider-trigger"
            className={classes.invisibleTrigger}
            aria-hidden="true"
          />
        </div>
        <div className={classes.sticky}>
          <h2 className={classes.title}>{title}</h2>
        </div>
      </section>
    </>
  )
}

export default withStyles(styles)(IntroStickySectionDivider)
